import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import ClickEvent = JQuery.ClickEvent;
import Dropdown, {DropdownProps} from "./Dropdown";
import {DceJsxRenderer} from "../../../dce-jsx";
import DceJsx from "dce-jsx/lib/jsx/DceJsx";

interface ColorPickerProps extends DropdownProps {
    palette: boolean
    paletteWidth: number;
    paletteHeight: number;
}

@Dce("ColorPicker")
export default class ColorPicker extends Dropdown {

    private static colors: string[] = [
        '#CCA6AC', '#FA573C', '#FBE983', '#16A765', '#4986E7', '#CD74E6', '#F83A22', '#FFAD46',
        '#F691B2', '#FF7537', '#B3DC6C', '#42D692', '#9A9CFF', '#AC725E',
        '#7BD148', '#9FE1E7', '#B99AFF', '#C2C2C2', '#D06B64', '#FAD165',
        '#92E1C0', '#9FC6E7', '#A47AE2', '#CABDBF'
    ];

    private PaletteSettings = {

        H_PARTS: 14,
        PART_COLORS: 12,

        HUE_DIFF: -10,

        SAT_START: 40,
        SAT_END: 95,

        LIGHT_START: 20,
        LIGHT_END: 95
    }

    private _colors: string[] = [];

    private _pickerProps: ColorPickerProps;

    constructor(elem: DceHTMLElement, props: ColorPickerProps) {
        super(elem, props);
    }

    protected colorClick(color:string){
        if(this.dropButton.is('input')){
            this.dropButton.val(color);
        }else{
            this.dropButton.find('input').val(color);
            this.dropButton.find('.preview').css({
                'background-color': color
            })
        }
    }

    protected setupDropdown() {

        this._pickerProps = {...this.defaultProps(), ...this._props} as ColorPickerProps;

        if(this._pickerProps.palette){
            this._colors = this.generatePalette();
        }else{
            this._colors = ColorPicker.colors;
        }

        let list = new ColorPickerList(this._colors, (s) => {
            this.colorClick(s);
        });

        this.dropdown = $('<div>');

        let maxWidth = '210px';
        if(this._pickerProps.palette){
            maxWidth = Math.ceil(this._pickerProps.paletteWidth * 20.3) + 'px';
        }

        this.dropdown.css({
            'position': 'fixed',
            'display': 'none',
            'max-width': maxWidth
        });

        this.dropdown.addClass('dropdown-container');

        list.appendTo(this.dropdown[0]);

        this.dropdown.appendTo($('body'));

        let color:string = '';

        if(this.dropButton.is('input')){
            color = this.dropButton.val() as string;
        }else{
            color = this.dropButton.find('input').val() as string;
        }

        this.dropButton.find('.preview').css({
            'background-color': color
        })

    }



    private generatePalette(): string[]{
        this.PaletteSettings = {

            H_PARTS: 16,
            PART_COLORS: 8,

            HUE_DIFF: 10,

            SAT_START: 55,
            SAT_END: 100,

            LIGHT_START: 25,
            LIGHT_END: 100
        };

        this.PaletteSettings.H_PARTS = this._pickerProps.paletteWidth;
        this.PaletteSettings.PART_COLORS = this._pickerProps.paletteHeight;

        let pal: string[][] = [];

        for(var h=0; h<this.PaletteSettings.H_PARTS; h++){
            var hue = (360/this.PaletteSettings.H_PARTS) * h;
            pal.push(this.generatePalettePart(hue));
        }

        console.log(pal);

        let colors:string[] = [];

        for (var i = 0; i < this.PaletteSettings.PART_COLORS; i++) {
            pal.forEach(v => {
                colors.push(v[i]);
            });
        }

        console.log(colors);

        return colors;
    }

    private generatePalettePart(hue: number): string[] {


        let result: string[] = [];

        for (var i = 0; i < this.PaletteSettings.PART_COLORS; i++) {

            var partHue = hue + ((this.PaletteSettings.HUE_DIFF / this.PaletteSettings.PART_COLORS) * i)
            if (partHue < 0) {
                partHue = 360 + partHue;
            }

            var partSat = this.PaletteSettings.SAT_START + ((this.PaletteSettings.SAT_END - this.PaletteSettings.SAT_START) / this.PaletteSettings.PART_COLORS) * i;

            var partLight = this.PaletteSettings.LIGHT_START + ((this.PaletteSettings.LIGHT_END - this.PaletteSettings.LIGHT_START) / this.PaletteSettings.PART_COLORS) * i;

            var rgb = this.hslToRgb(
                partHue / 360, partSat / 100, partLight / 100
            );

            result.push(
                this.rgbAsHex(rgb)
            )

        }

        return result;

    }

    private rgbAsHex(rgb: number[]): string{

        return '#' + rgb.map((val) => {
            var hex = val.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
        }).join('');

    }

    /**
     * Converts an HSL color value to RGB. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes h, s, and l are contained in the set [0, 1] and
     * returns r, g, and b in the set [0, 255].
     *
     * @param   {number}  h       The hue
     * @param   {number}  s       The saturation
     * @param   {number}  l       The lightness
     * @return  {Array}           The RGB representation
     */
    private hslToRgb(h: number, s: number, l: number): number[]{

        var r, g, b;

        if(s == 0){
            r = g = b = l; // achromatic
        }else{
            var hue2rgb = function hue2rgb(p: number, q:number, t:number){
                if(t < 0) t += 1;
                if(t > 1) t -= 1;
                if(t < 1/6) return p + (q - p) * 6 * t;
                if(t < 1/2) return q;
                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                return p;
            }

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    defaultProps(): Partial<ColorPickerProps> {

        return {
            dropdown: '__',
            hideOnClickDropdown: true,
            horizontalOffset: 0,
            horizontalPos: 'left',
            verticalOffset: 0,
            verticalPos: 'bottom',
            palette: true,
            paletteWidth:16,
            paletteHeight: 8
        }
    }
}

class ColorPickerList extends DceJsxRenderer {

    private colors: string[];

    private onClickCallback: (color: string) => void;

    constructor(colors: string[], onClickCallback: (color: string) => void) {
        super();
        this.colors = colors;
        this.onClickCallback = onClickCallback;
    }

    private colorClick(a: any) {
        let event:MouseEvent = a as MouseEvent;

        this.onClickCallback(
            (event.target as HTMLElement).getAttribute('data-color')
        );
    }

    render(): JSX.Element {
        return (
            <div style={{lineHeight: '1px'}}>
                {
                    this.colors.map((color) => {

                        let itemStyle = {
                            display: 'inline-block',
                            width: '16px',
                            height: '16px',
                            margin: '2px',
                            backgroundColor: color
                        }

                        return <span data-color={color} style={itemStyle} onClick={e => this.colorClick(e)}></span>
                    })
                }
            </div>
        )
    }



}

